import React, { Component } from 'react';

class PDABaseClass extends Component {
  constructor(props) {
    super(props);
  }

  showLoading () {
    this.setState(prevState => ({
      ...prevState,
      loadingData: true,
    }));
  }

  hideLoading () {
    this.setState(prevState => ({
      ...prevState,
      loadingData: false,
    }));
  }

}

export default PDABaseClass;
